const frTrans = {
   "?Français": "Français",
   "?Anglais": "Anglais",
   "?turn_landscape": "Veuillez tourner votre appareil en mode \"Paysage\" SVP.",
   "?Veuillez vous identifier": "Veuillez vous identifier",
   "?Serveur": "Serveur",
   "?Projet": "Projet",
   "?Identifiant": "Identifiant",
   "?Mot de passe": "Mot de passe",
   "?Votre mot de passe": "Votre mot de passe",
   "?Se souvenir de moi": "Se souvenir de moi",
   "?Mot de passe oublié": "Mot de passe oublié",
   "?S'identifier": "S'identifier",
   "?Gamme": "Gamme|Gammes",
   "?Par gamme": "Par gamme",
   "?Collection": "Collection|Collections",
   "?Sous-collection": "Sous-collection|Sous-collections",
   "?Par collection": "Par collection",
   "?Famille": "Famille|Familles",
   "?Par famille": "Par famille",
   "?Porté": "Porté|Portés",
   "?Par porté": "Par porté",
   "?Typologie": "Typologie|Typologies",
   "?Couleur": "Couleur|Couleurs",
   "?Univers": "Univers",
   "?Cycle": "Cycle|Cycles",
   "?Param comm": "Paramètre commercial",
   "?Taille": "Taille",
   "?Quantité": "Quantité",
   "?Dashboard": "Dashboard",
   "?Accueil": "Accueil",
   "?Catalogue": "Catalogue",
   "?Client": "Client|Clients",
   "?Paramètres": "Paramètres",
   "?Langue": "Langue",
   "?Tarif": "Tarif|Tarifs",
   "?Autre": "Autre|Autres",
   "?Commandes en cours": "Commandes en cours",
   "?Nouvelle commande": "Nouvelle commande",
   "?Retour au catalogue": "Retour au catalogue",
   "?Prix": "Prix",
   "?Poids": "Poids",
   "?Poids diamants": "Poids diamants",
   "?Diamants": "Diamants",
   "?Ecrin": "Ecrin|Ecrins",
   "?Bijou": "Bijou|Bijoux",
   "?À partir de": "À partir de",
   "?QTÉ": "QTÉ",
   "?Qté": "Qté",
   "?Longueur": "Longueur",
   "?Largeur": "Largeur",
   "?Hauteur": "Hauteur",
   "?Poids brut": "Poids brut",
   "?Poids net": "Poids net",
   "?Par combien": "PCB",
   "?pds_g": "g",
   "?pds_kg": "kg",
   "?pds_ct": "ct",
   "?len_m": "m",
   "?len_cm": "cm",
   "?Sélecteur de quantité": "Sélecteur de quantité",
   "?Vérifier disponibilité": "Vérifier disponibilité",
   // "EUR": "€,R",     // Placer à droite
   // "USD": "$,L",     // Placer à gauche
   // "HKD": "HKD,L",   // Placer à gauche
   // "SGD": "SG$,L",   // Placer à gauche
   // "AUD": "AU$,L",   // Placer à gauche
   // "JPY": "¥,L",     // Placer à gauche
   // "WON": "₩,L",     // Placer à gauche
   // "CAD": "CA$,L",   // Placer à gauche
   // "CNY": "CNY,L",   // Placer à gauche
   // "DKK": "DKK,L",   // Placer à gauche
   // "CHF": "CHF,L",   // Placer à gauche
   // "MOP": "MOP,L",   // Placer à gauche
   // "MAD": "MAD,L",   // Placer à gauche
   // "NOK": "NOK,L",   // Placer à gauche
   // "SEK": "SEK,L",   // Placer à gauche
   // "GBP": "£,L",   // Placer à gauche
   "?Saisie multiple": "Saisie multiple",
   "?Disponible": "Disponible",
   "?Indisponible": "Indisponible",
   "?Pas de stock": "Pas de stock",
   "?Non communiqué": "Non communiqué",
   "?Ajouter à la commande": "Ajouter à la commande",
   "?Ajouter aux quotas": "Ajouter aux quotas",
   "?Modifier la commande": "Modifier la commande",
   "?Modifier les quotas": "Modifier les quotas",
   "?Aucune commande sélectionnée": "Aucune commande sélectionnée",
   "?Aucun client sélectionné": "Aucun client sélectionné",
   "?Annuler": "Annuler",
   "?Non": "Non",
   "?OK": "OK",
   "?Oui": "Oui",
   "?Purger le cache": "Purger le cache",
   "?Purger les tarifs": "Purger les tarifs",
   "?x_sur_y": "sur",
   "?Filtre": "Filtre|Filtres",
   "?Appliquer": "Appliquer",
   "?Se déconnecter": "Se déconnecter",
   "?NC": "NC",
   "?Gratuit": "Gratuit",
   "?keypad_hint_physical_keyboard": "Astuce : vous pouvez aussi saisir avec le clavier de l'ordinateur",
   "?Réinitialiser les préférences": "Réinitialiser les préférences",
   "?Réinitialiser + nouvel udid": "Réinitialiser + nouvel udid",
   "?warn_expert_mode": "ATTENTION, en mode Expert ne changez rien sans y être invité par le service technique.",
   "?Repasser en mode Normal": "Repasser en mode Normal",
   "?Passer en mode Expert": "Passer en mode Expert",
   "?Format d'heure": "Format d'heure",
   "?Format de date": "Format de date",
   "?Priorité des images": "Priorité des images",
   "?by Messika": "by Messika",
   "?Interne": "Interne",
   "?DD-MM-YYYY": "JJ-MM-AAAA",
   "?MM-DD-YYYY": "MM-JJ-AAAA",
   "?YYYY-MM-DD": "AAAA-MM-JJ",
   "?YYYY-DD-MM": "AAAA-JJ-MM",
   "?min_length": "Longueur mini avant de lancer le filtrage",
   "?Fermeture popups": "Fermeture popups",
   "?Borneur de prix": "Borneur de prix",
   "?Bouton seulement": "Bouton seulement",
   "?Partout": "Partout",
   "?Gauche": "Gauche",
   "?Centré": "Centré",
   "?pas chargé": "pas chargé",
   "?chargé": "chargé|chargés",
   "?list_length_per_page": "Lignes par page dans les listes",
   "?Afficher ascenseurs": "Afficher ascenseurs",
   "?Thème alternatif (test couleurs)": "Thème alternatif (test couleurs)",
   "?Afficher le toggle de thème global": "Afficher le toggle de thème global",
   "?Paramètres régionaux": "Paramètres régionaux",
   "?Interface": "Interface",
   "?Période d'absence": "Période d'absence",
   "?du": "du",
   "?au": "au",
   "?inclus": "inclus",
   "?Les deux dates sont obligatoires et \"du\" doit être avant ou égal à \"au\".": "Les deux dates sont obligatoires et « du » doit être avant ou égal à « au ».",
   "?Absence enregistrée : du": "Absence enregistrée : du",
   "?Enregistrer": "Enregistrer",
   "?Effacer": "Effacer",
   "?Position catalogue": "Affichage catalogue",
   "?max_buttons_on_lists": "Nb de boutons de page sur les listes",
   "?Quitter le client": "Quitter le client",
   "?Quitter commande": "Quitter commande",
   "?Sélectionner": "Sélectionner",
   "?Envoyer en PDF à...": "Envoyer en PDF à...",
   "?Dupliquer": "Dupliquer",
   "?Synchroniser": "Synchroniser",
   "?Sync": "Sync",
   "?Sync depuis": "Sync depuis",
   "?Dernière sync": "Dernière sync",
   "?Forcer une date...": "Forcer une date...",
   "?Forcer sync à partir de": "Forcer sync à partir de",
   "?Signature client": "Signature client",
   "?Toutes collections": "Toutes collections",
   "?Toutes familles": "Toutes familles",
   "?Tous": "Tous",
   "?Toutes": "Toutes",
   "?Supprimer": "Supprimer",
   "?Modifier": "Modifier",
   "?N° Cde": "N° Cde",
   "?N°": "N°",
   "?Nom client": "Nom client",
   "?Téléphone": "Téléphone",
   "?Email": "Email|Emails",
   "?Date": "Date",
   "?Prix total": "Prix total",
   "?Total": "Total",
   "?Livraison": "Livraison",
   "?Action": "Action|Actions",
   "?Pièces": "Pièces",
   "?Modèle": "Modèle|Modèles",
   "?Commande": "Commande|Commandes",
   "?Commande ECR": "Commande ECR",
   "?Commande ECF": "Commande ECF",
   "?Commande Retail": "Commande Retail",
   "?Libellé": "Libellé",
   "?Commentaire": "Commentaire",
   "?Commentaire ligne": "Commentaire ligne",
   "?Cess.": "Cess.",    // P. Cession
   "?Vider": "Vider",
   "?Trié par": "Trié par",
   "?Nom": "Nom",
   "?Affichage de": "Affichage de",
   "?Précédentes": "Précédentes",
   "?Suivantes": "Suivantes",
   "?par page": "par page",
   "?Entre": "Entre",
   "?et": "et",
   "?oui": "oui",
   "?non": "non",
   "?Retour": "Retour",
   "?Voir les tarifs": "Voir les tarifs",
   "?Masquer les tarifs": "Masquer les tarifs",
   "?Adresse": "Adresse|Adresses",
   "?Adresse de livraison": "Adresse de livraison|Adresses de livraison",
   "?Voir": "Voir",
   "?Créer une commande": "Créer une commande",
   "?Créer une ECR": "Créer une commande ECR",
   "?Créer une ECF": "Créer une commande ECF",
   "?Créer une commande Retail": "Créer une commande Retail",
   "?Créer un modèle": "Créer un modèle",
   "?Ecrire un mail": "Ecrire un mail",
   // "Voir les contacts": "Voir les contacts",
   // "Voir les adresses": "Voir les adresses",
   // "Voir les stats": "Voir les stats",
   "?Voir les infos": "Voir les infos",
   "?Afficher puce pour byMessika": "Afficher puce pour byMessika",
   "?Formater numéros de téléphone": "Formater numéros de téléphone",
   "?Code": "Code",
   "?Informations": "Informations",
   "?Stats": "Stats",
   "?Contact": "Contact|Contacts",
   "?N° de commande": "N° de commande",
   "?Supprimer toutes les commandes": "Supprimer toutes les commandes",
   "?Suppression": "Suppression",
   "?confirmer_suppression_bdc": "Souhaitez-vous réellement supprimer cette commande ?",
   "?confirmer_suppression_ligne": "Souhaitez-vous réellement supprimer cet article de votre commande ?",
   "?confirmer_synchronisation_bdc": "Souhaitez-vous réellement synchroniser ces commandes ?",
   "?confirmer_soumission_bdc": "Souhaitez-vous réellement soumettre les commandes Retail (ECR/ECF) sélectionnées pour validation ?",
   "?confirmer_soumission_retail": "Souhaitez-vous soumettre cette commande Retail\npour validation ?|Souhaitez-vous soumettre ces commandes Retail\npour validation ?",
   "?Synchronisation": "Synchronisation",
   "?Valider": "Valider",
   "?Afficher les numéros de semaine (date picker)": "Afficher les numéros de semaine (date picker)",
   "?Quantité maxi par ligne de commande": "Quantité maxi par ligne de commande",
   "?Nouvelle commande %1 créée et activée": "Nouvelle commande %1 créée et activée",
   "?article": "article|articles",
   "?delay_show_cess": "Délai appui pour montrer les prix de cession (ms)",
   "?history_size": "Taille des historiques (commandes, clients...)",
   "?Garder historique ouvert": "Garder historique ouvert",
   "?reste x_sur_y cars": "Il reste %1 caractère sur %2|Il reste %1 caractères sur %2",
   "?Contremarque": "Contremarque",
   "?Implantation": "Implantation",
   "?Triangulaire": "Triangulaire",
   "?Vérifier disponibilité sur %1": "Vérifier disponibilité sur %1",
   "?Disponible sur %1": "Disponible sur %1",
   "?Indisponible sur %1": "Indisponible sur %1",
   "?Non communiqué sur %1": "Non communiqué sur %1",
   "?Confié": "Confié|Confiés",
   "?Devis": "Devis",
   "?Paramétrer": "Paramétrer",
   "?Ajout de ligne par SKU": "Ajout de ligne par SKU",
   "?Chercher un SKU": "Chercher un SKU",
   "?Recherche dans le catalogue": "Recherche dans le catalogue",
   "?Recherche dans cette commande": "Recherche dans cette commande",
   "?item_X_added2order": "Article %1 ajouté à la commande|Article %1 ajouté en %2 exemplaires à la commande",
   "?item_X_replaced_in_order": "Ligne %1 remplacée — nouvelle quantité : %2",
   "?item_X_cumulated_in_order": "Ligne %1 cumulée — nouvelle quantité : %2",
   "?X_lignes_ajoutees": "%1 ligne ajoutée à la commande|%1 lignes ajoutées à la commande",
   "?Quantité invalide": "Quantité invalide",
   "?Quantité invalide pour X": "Quantité invalide : %1",
   "?Erreurs ajout SKU": "Erreurs lors de l'ajout",
   "?PCB": "PCB",
   "?Afficher le PCB": "Afficher le PCB",
   "?SKU déjà présent": "SKU déjà présent",
   "?sku_duplicate_info": "Le SKU %1 est déjà présent dans la commande (quantité actuelle : %2).",
   "?sku_duplicate_question": "Voulez-vous remplacer par %1 ou cumuler à %2 ?",
   "?Cumuler": "Cumuler",
   "?Remplacer": "Remplacer",
   "?SKU inconnu": "SKU %1 inconnu : aucun modèle ne correspond",
   "?SKU bijou dans commande retail": "Le SKU %1 est un article bijou : il ne peut pas être ajouté à une commande retail",
   "?SKU bijou dans quota retail": "Le SKU %1 est un article bijou : il ne peut pas être ajouté à un quota retail",
   "?SKU bijou dans modele quota retail": "Le SKU %1 est un article bijou : il ne peut pas être ajouté à un modèle de quota retail",
   "?SKU retail dans commande bijou": "Le SKU %1 est un article retail : il ne peut pas être ajouté à une commande bijou",
   "?Aucun prix pour ce SKU": "Aucun prix trouvé pour le SKU %1 dans cette région",
   "?SKU errone corrige": "Le SKU %1 était erroné et a été corrigé en %2 — %3",
   "?Cet article n'a pas de taille": "Cet article n'a pas de taille",
   "?Cet article n'a pas de couleur": "Cet article n'a pas de couleur",
   "?SKU rejete": "SKU %1 rejeté — %2",
   "?Couleur manquante": "Couleur manquante",
   "?Couleur inconnue": "Couleur inconnue",
   "?Taille manquante": "Taille manquante",
   "?Taille inconnue": "Taille inconnue",
   "?Quota retail dépassé": "Quota dépassé pour le SKU %1 : %2 unité(s) disponible(s)",
   "?Quota retail non applicable": "Aucun quota applicable pour ce client à cette période",
   "?Remise": "Remise",
   "?Remise ligne": "Remise ligne",
   "?Remise invalide (0-100)": "Remise invalide (entrez un % entre 0 et 100)",
   "?Type": "Type",
   "?max_tarifs_offline": "Nb maxi de tarifs préchargeable pour le mode déconnecté",
   "?Montrer l'état": "Montrer l'état",
   "?Seulement les tarifs cochés": "Seulement les tarifs sélectionnés",
   "?nb_tarifs_sel_sur_x": "%1 tarif sélectionné sur %2|%1 tarifs sélectionnés sur %2",
   "?dont_x_dispo_deco": "dont %1 disponible en mode déconnecté (maxi %2)|dont %1 disponibles en mode déconnecté (%2 max.)",
   "?Préchargé": "Préchargé",
   "?Mode déconnecté": "Mode déconnecté",
   "?Région": "Région",
   "?Listé": "Listé",
   "?Chargé": "Chargé",
   "?Chargé si besoin": "Chargé si besoin",
   "?Erreur de chargement": "Erreur de chargement",
   "?Non sélectionné": "Non sélectionné",
   "?Préparation offline": "Préparation offline",
   "?Support": "Assistance",
   "?oMe_subject_support": "oMe - Demande d'assistance",
   "?Appeler": "Appeler",
   "?Préparer le mode offline": "Préparer le mode offline",
   "?Fermer": "Fermer",
   "?Terminé": "Terminé",
   "?Envoyer": "Envoyer",
   "?Importer": "Importer",
   "?Envoi en cours": "Envoi en cours",
   "?txt_sync_annulé": "Préparation offline annulée. Il manquera des images si vous perdez votre connexion Internet !",
   "?load_offline_assets": "Chargement des données pour travailler en mode déconnecté",
   "?Page d'assistance": "Page d'assistance",
   "?assist_wrong": "Si vous êtes arrivés ici par erreur :",
   "?assist_send_prefs": "Si le service IT vous le demande, envoyez vos données techniques à l'aide de ce bouton :",
   "?assist_got_prefs": "Une mise à jour de vos données techniques a été préparée par le service IT. Voulez-vous l'importer ?",
   "?impersonate_as": "Emprunt identité : se connecter en tant que (email)",
   "?Continuer": "Continuer",
   "?impersonate_warn_title": "Connexion en tant qu'un autre compte",
   "?impersonate_warn_purge": "Toute la base locale va être effacée (clients, commandes, BI, confiés, RAL, caches images)",
   "?impersonate_warn_as": "pour vous connecter en tant que",
   "?impersonate_warn_return": "Le retour à votre compte effacera aussi toute la base locale.",
   "?impersonate_warn_unsynced": "Attention : %1 commande(s) non synchronisée(s) sur cet appareil seront perdues.",
   "?impersonate_banner_login": "Connexion en tant que",
   "?impersonate_banner_login_2a": "Saisissez",
   "?impersonate_banner_login_2b": "VOTRE",
   "?impersonate_banner_login_2c": "identifiant et",
   "?impersonate_banner_login_2d": "VOTRE",
   "?impersonate_banner_login_2e": "mot de passe.",
   "?impersonation_refused": "Emprunt identité refusé : vérifier le droit impersonator du compte et l'email cible",
   "?impersonation_refused_no_right": "Emprunt identité refusé : le compte %1 n'a pas le droit impersonator",
   "?impersonation_refused_unexpected": "Emprunt identité refusé : réponse inattendue (%1)",
   "?impersonation_refused_error": "Emprunt identité refusé : %1",
   "?impersonation_forbidden_server": "Emprunt identité refusé par le serveur : droit impersonator absent",
   "?impersonation_target_not_found_server": "Emprunt identité : compte cible introuvable sur le serveur",
   "?impersonate_banner": "Connecté en tant que %1 — opérateur : %2",
   "?impersonate_exit": "Quitter l'emprunt identité",
   "?impersonate_exit_warn": "Toute la base locale va être effacée.",
   "?impersonate_exit_warn_2": "Vous pourrez ensuite vous connecter normalement.",
   "?impersonate_offline_refused": "Réseau requis pour reprendre l'emprunt identité",
   "?impersonate_back": "Revenir à mon compte",
   "?impersonate_back_title": "Revenir à mon compte",
   "?impersonate_back_warn": "Toute la base locale va être effacée.",
   "?impersonate_back_warn_2": "Vous devrez vous reconnecter avec votre compte (synchronisation complète).",
   "?impersonate_title": "Emprunt identité",
   "?impersonate_refresh": "Rafraîchir les données",
   "?impersonate_refresh_progress": "Rafraîchissement des données…",
   "?impersonate_refresh_done": "Données à jour",
   "?impersonate_as_label": "En tant que",
   "?impersonate_operator": "Opérateur",
   "?impersonate_toggle": "Afficher / masquer le détail",
   "?Durée maxi d'inactivité": "Durée maxi d'inactivité",
   "?Fin de session dans": "Fin de session dans",
   "?Erreur de récupération des données": "Erreur de récupération des données",
   "?Erreur inconnue": "Erreur inconnue",
   "?Accès refusé": "Accès refusé",
   "?clean_db": "Si le service IT vous le demande, videz :",
   "?Base de données": "Base de données",
   "?Commandes (Danger !)": "Commandes (Danger !)",
   "?Images clés": "Images clés",
   "?Images modèles": "Images modèles",
   "?Global": "Global",
   "?Quitter cette page": "Quitter cette page",
   "?Tarif à télécharger": "Tarif à télécharger",
   "?Télécharger le tarif": "Télécharger le tarif",
   "?Téléchargement du tarif": "Téléchargement du tarif",
   // "?Le tarif du client n'est pas dans votre liste !": "Le tarif du client n'est pas dans votre liste !",
   "?Le tarif du client est inconnu !": "Le tarif du client est inconnu !",
   "?Voir dans le catalogue": "Voir dans le catalogue",
   "?Forcer synchronisation": "Forcer synchronisation",
   "?Traitée": "Traitée|Traitées",
   "?En cours oMe": "En cours oMe",
   "?Prix public": "Prix public",
   "?order_cloned": "Vous travaillez maintenant sur la commande dupliquée",
   "?Détail": "Détail|Détails",
   "?Chercher un client": "Chercher un client",
   "?Chercher un client (code, nom, ville, pays, clé)": "Chercher un client (code, nom, ville, pays, clé)",
   "?Chercher une commande": "Chercher une commande",
   "?Description": "Description",
   "?Adresse mail": "Adresse mail|Adresses mail",
   "?Message": "Message",
   "?Envoyer mail": "Envoyer mail",
   "?Documentation": "Documentation",
   "?Mot de passe unique": "Mot de passe unique",
   "?OTP_scan1": "Scannez ce QRCode ou collez-le dans votre logiciel OTP. Pour des raisons de sécurité, ne le conservez pas ailleurs !",
   "?OTP_scan2": "Puis saisissez ici le code à 6 chiffres généré par votre application OTP :",
   "?Code OTP": "Code OTP",
   "?6 chiffres": "6 chiffres",
   "?Envoyer le code": "Envoyer le code par email",
   "?Renvoyer": "Renvoyer le code",
   "?Code reçu par email": "Code reçu par email",
   "?Nouveau mot de passe": "Nouveau mot de passe",
   "?Votre nouveau mot de passe": "Votre nouveau mot de passe",
   "?check_mailbox_for_pin": "Consultez votre messagerie : le code à saisir ci-dessous vous a été envoyé par email.",
   "?pwd_rule_length": "10 caractères minimum",
   "?pwd_rule_lower": "Une minuscule",
   "?pwd_rule_upper": "Une majuscule",
   "?pwd_rule_digit": "Un chiffre",
   "?pwd_rule_symbol": "Un caractère qui n'est ni une lettre ni un chiffre (symbole, ponctuation, accent…)",
   "?pwd_too_weak": "Le nouveau mot de passe ne respecte pas les règles requises.",
   "?pin_sent": "Si un compte existe pour cet identifiant, un code vient d'être envoyé par email.",
   "?Saisissez votre identifiant": "Saisissez d'abord votre identifiant.",
   "?Masquer": "Masquer",
   "?Changer le mot de passe": "Changer le mot de passe",
   "?resetpwd_ok": "Mot de passe changé",
   "?resetpwd_nok": "Impossible de changer le mot de passe !",
   "?Mauvais code": "Mauvais code",
   "?Pièce": "Pièce|Pièces",
   "?Ventes": "Ventes",
   "?Reste à livrer": "Reste à livrer",
   "?Limite crédit": "Limite de crédit",
   "?hist_commandes": "Récupération de %1 commande…|Récupération de %1 commandes…",
   "?Vérification des commandes": "Vérification des commandes…",
   "?chiffre_affaires": "Chiffre d'affaires",
   "?Mois": "Mois",
   "?À livrer": "À livrer",
   "?Vers": "Vers",
   "?Exclusivité boutique": "Exclusivité boutique",
   "?Template": "'Modèle|Modèles",
   "?Prospect": "Prospect|Prospects",
   "?Bienvenue": "Bienvenue",
   "?Retail": "Retail",
   "?Retail interne": "ECR",
   "?Retail externe": "ECF",
   "?SKU": "SKU",
   "?Aucune ligne": "Aucune ligne",
   "?Dimensions": "Dimensions",
   "?Commande incompatible": "Commande incompatible",
   "?Sur commande/Devis": "Sur commande/Devis",
   "?Mesures": "Mesures",
   "?mesures_lg_totale": "Longueur totale du produit (cm) :",
   "?mesures_tour_cou": "Tour de cou (cm) :",
   "?mesures_tour_poignet": "Tour de poignet (cm) :",
   "?mesures_largeur": "Largeur du produit (mm) :",
   "?mesures_lg_chaine": "Longueur de chaîne (cm) :",
   "?mesures_nb_anneaux": "Nb d'anneaux de fermeture :",
   "?Pierres": "Pierres",
   "?pierres_nb_certif_gia": "Nb de pierres certifiées GIA :",
   "?pierres_nb_certif_sarines": "Nb de pierres certifiées SARINE :",
   "?pierres_nb_certif_autres": "Nb de pierres certifiées AUTRE :",
   "?pierres_nb_centres": "Nb de pierres de centre :",
   "?Si boucles d'oreilles": "Si boucles d'oreille",
   "?Mono": "Mono",
   "?Paire": "Paire",
   "?BEST SELLER": "BEST SELLER",
   "?WARNING": "WARNING",
   "?ICONIC": "ICONIC",
   "?SPO": "COMMANDE SPÉCIALE",
   "?SURCO": "SUR COMMANDE",
   "?Quotas": "Quotas",
   "?Quota actuel": "Quota actuel",
   "?Quota dépassé": "Quota dépassé",
   "?Quota épuisé": "Quota épuisé",
   "?Hors quota": "Hors quota",
   "?Dépassement autorisé": "Dépassement autorisé",
   "?Restant": "Restant",
   "?Quota restant": "Quota restant",
   "?(hors cette cde)": "(hors cette cde)",
   "?Dépôt": "Dépôt",
   "?Collision": "Collision",
   "?collision": "collision|collisions",
   "?Quota existant pour cette période — sera modifié selon les options ci-dessous": "Quota existant pour cette période — sera modifié selon les options ci-dessous",
   "?Synchroniser vers M3": "Validation finale",
   "?Validation finale et envoi M3": "Validation finale et envoi M3",
   "?Soumettre au valideur final": "Soumettre au valideur final",
   "?Soumettre la commande pour validation": "Soumettre la commande pour validation",
   "?msg_validation_finale": "Cette validation est définitive.\nLa commande sera verrouillée et synchronisée vers M3.",
   "?msg_soumettre_n1": "La commande va être transmise au valideur final.",
   "?msg_soumettre_validation": "La commande va être transmise à un valideur. Vous ne pourrez plus la modifier ni la voir tant qu'elle est en cours de validation.",
   "?Cons.": "Cons.",
   "?Rest.": "Rest.",
   "?Valider vers N1": "Valider vers N1",
   "?Validation finale": "Validation finale",
   "?Renvoyer au client": "Renvoyer au client",
   "?msg_send_to_client": "Envoyer cette commande au client ?\nVous perdrez la main dessus (elle passe en brouillon côté client).",
   "?msg_return_to_client": "Renvoyer cette commande au client ?\nVous perdrez la main dessus (elle repasse en brouillon côté client).",
   "?Envoyer au client": "Envoyer au client",
   "?Erreur lors de l'envoi au client": "Erreur lors de l'envoi au client",
   "?Reliquat de": "Reliquat de",
   "?Envoi vers N2": "Envoi vers N2",
   "?Garder reliquat": "Garder reliquat",
   "?Confirmer la validation finale de cette commande ?": "Confirmer la validation finale de cette commande ?",
   "?Reliquat détecté": "Reliquat détecté",
   "?order_stale": "Cette commande a évolué ou ne vous est plus accessible.",
   "?order_action_failed": "Action impossible pour le moment, réessayez.",
   "?order_save_failed": "Échec de l'enregistrement de la commande (droits insuffisants ou réseau).",
   "?Quota": "Quota",
   "?Consommé": "Consommé",
   "?PU": "PU",
   "?Stock": "Stock",
   "?NEW": "NEW",
   "?Tout refuser": "Tout refuser",
   "?Ajouter ligne": "Ajouter ligne",
   "?Référence SKU": "Référence SKU",
   "?Annuler les modifications": "Annuler les modifications",
   "?Quitter la validation": "Quitter la validation",
   "?Quitter validation": "Quitter validation",
   "?Ouvrir validation...": "Ouvrir validation...",
   "?Toutes les modifications seront perdues.": "Toutes les modifications seront perdues.",
   "?Annuler suppression": "Annuler suppression",
   "?Chargement": "Chargement",
   "?acceptée": "acceptée|acceptées",
   "?refusée": "refusée|refusées",
   "?ajoutée": "ajoutée|ajoutées",
   "?modifiée": "modifiée|modifiées",
   "?supprimée": "supprimée|supprimées",
   "?inchangée": "inchangée|inchangées",
   "?vs_demande_client": "(par rapport à la demande initiale du client)",
   "?aucune ligne conservée": "aucune ligne conservée",
   "?ligne": "ligne|lignes",
   "?Référence": "Référence",
   "?Intitulé": "Intitulé",
   "?Init.": "Init.",
   "?Final": "Final",
   "?Reliq.": "Reliq.",
   "?Exporter CSV": "Exporter CSV",
   "?Exporter Excel": "Exporter Excel",
   "?Importer CSV/Excel": "Importer CSV/Excel",
   "?Importer quota": "Importer quotas",
   "?Créer...": "Créer...",
   "?Quota Retail": "Quotas Retail",
   "?Créer des quotas": "Créer des quotas",
   "?Créer de nouveaux quotas": "Créer de nouveaux quotas",
   "?Modèle Quotas": "Modèle Quotas",
   "?Ce modèle quota existe déjà": "Ce modèle quota existe déjà",
   "?Ce quota existe déjà": "Ce quota existe déjà pour ce client à cette période",
   "?confirmer_suppression_modele": "Souhaitez-vous réellement supprimer ce modèle ?",
   "?Ajouter": "Ajouter",
   "?Remplacer l'existant": "Remplacer l'existant",
   "?Cumuler les quantités": "Cumuler les quantités",
   "?Choisir le mode d'import": "Choisir le mode d'import",
   "?Import : SKU manquant, inconnu ou quantité invalide": "Import : SKU manquant, inconnu ou quantité invalide. Vérifiez le fichier.",
   "?Fichier importé avec succès": "Fichier importé avec succès",
   "?Aucune ligne valide dans le fichier": "Aucune ligne valide dans le fichier",
   "?Erreur lors de la lecture du fichier": "Erreur lors de la lecture du fichier",
   "?Quota créé et lignes importées": "Quotas créés et lignes importées",
   "?À valider": "À valider",
   "?Soumises": "Soumises",
   "?Soumettre": "Soumettre",
   "?Remise globale": "Remise globale",
   "?Sauvegarde locale": "Sauvegarde locale",
   "?Restaurer une sauvegarde": "Restaurer une sauvegarde",
   "?Sauvegarde": "Sauvegarde",
   "?Fichier JSON invalide": "Fichier JSON invalide (id, customer_id ou lines manquants)",
   "?Commande restaurée": "Commande restaurée",
   "?Commande %1 importée": "Commande %1 importée",
   "?La commande courante sera écrasée par le contenu du fichier.": "La commande courante sera écrasée par le contenu du fichier.",
   "?Une nouvelle commande %1 sera créée.": "Une nouvelle commande %1 sera créée.",
   "?L'identifiant de la commande ne sera pas modifié.": "L'identifiant de la commande ne sera pas modifié.",
   "?Écraser": "Écraser",
   "?Type incompatible : %1 ≠ %2": "Type incompatible : %1 ≠ %2",
   "?Client incompatible : %1 ≠ %2": "Client incompatible : %1 ≠ %2",
   "?Créer depuis sauvegarde": "Créer depuis sauvegarde",
   "?Commande %1 créée depuis sauvegarde": "Commande %1 créée depuis sauvegarde",
   "?Sélection de": "Sélection de",
   "?Déployer vers clients": "Déployer vers clients",
   "?Supprimer le déploiement": "Supprimer le déploiement",
   "?Déploiement en cours": "Déploiement en cours",
   "?Suppression du déploiement en cours": "Suppression du déploiement en cours",
   "?Les clients suivants ont des quotas pour la période %1.": "Les clients suivants ont des quotas pour la période %1.",
   "?Les quotas des clients sélectionnés seront supprimés :": "Les quotas des clients sélectionnés seront supprimés :",
   "?Aucun client concerné pour cette période": "Aucun client concerné pour cette période",
   "?Déployer": "Déployer",
   "?Sans quota": "Sans quota",
   "?Avec quotas": "Avec quotas",
   "?sélectionné": "sélectionné|sélectionnés",
   "?déjà avec quotas": "déjà avec quotas",
   "?Chargement...": "Chargement…",
   "?Aucun client éligible": "Aucun client éligible",
   "?ID": "ID",
   "?Quotas existants": "Quotas existants",
   "?Pour les clients ayant déjà des quotas :": "Pour les clients ayant déjà des quotas :",
   "?Remplacer les quantités existantes": "Remplacer les quantités existantes",
   "?Ajouter les nouvelles lignes": "Ajouter les nouvelles lignes",
   "?Supprimer les lignes absentes": "Supprimer les lignes absentes",
   "?Aucune option : les quotas existants ne seront pas modifiés.": "Aucune option : les quotas existants ne seront pas modifiés.",
   "?KTM vide : les quotas existants des clients sélectionnés pour cette période seront supprimés.": "KTM vide : les quotas existants des clients sélectionnés pour cette période seront supprimés.",
   "?Période invalide sur le KTM": "Période invalide sur le KTM",
   "?créé": "créé|créés",
   "?mis à jour": "mis à jour",
   "?supprimé": "supprimé|supprimés",
   "?ignoré": "ignoré|ignorés",
   "?Déploiement terminé": "Déploiement terminé",
   "?pwa_updating": "Mise à jour de l'application…",
   "?pwa_new_version": "Nouvelle version disponible",
   "?pwa_reload": "Recharger",
   "?pwa_db_incompatible": "Cette version de l'application est incompatible avec les données locales de cet appareil. Contactez le support.",
}

export default frTrans